import React, { Component } from "react";
import axios from "axios";
import LoaderPanel from "../components/LoaderPanel";
import SaveNavbar from "../components/SaveNavbar";
import parse from "../utils/parse";
import _ from "underscore";
import moment from "moment";
import { Table } from "react-bootstrap";
import { EDTableSection } from "../components/EDDOM";

const eventNames = {
    'open': 'Opens',
    'click': 'Clicks',
    'bounce': 'Bounces',
    'unsub': 'Unsubscribes',
    'complaint': 'Complaints',
};

export default class BroadcastDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      reloading: false,
    };
  }

  componentWillMount() {
    this.reload();
  }

  refresh = async () => {
    this.setState({reloading: true});
    try {
      await this.reload();
    } finally {
      this.setState({reloading: false});
    }
  }

  async reload() {
    var p = parse(this);
    this.setState({data: _.sortBy((await axios.get('/api/broadcasts/' + p.id + '/details?cmd=' + p.cmd + (p.domain ? '&domain=' + p.domain : ''))).data, 'email')});
  }

  goBack = () => {
    var p = parse(this);

    this.props.history.push(p.returnto);
  }

  render() {
    var p = parse(this);

    return (
      <SaveNavbar isAdmin={true} title={`View ${p.isbc === 'true' ? 'Broadcast' : 'Message'} ${eventNames[p.cmd]} ${p.domain ? ' for ' + p.domain : ''}`} onBack={this.goBack} hideSave={true}>
        <LoaderPanel isLoading={this.props.isLoading}>
          <EDTableSection>
          {
            this.state.data !== null &&
              (this.state.data.length ?
                <Table className="space15 log-table" responsive>
                  <thead>
                    <tr>
                      <th>Email</th>
                      <th>Date/Time</th>
                      {
                        p.cmd === 'bounce' && <th>Message</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {
                      _.map(this.state.data, m => <tr key={m.email}>
                        <td>{m.email}</td>
                        <td>{moment(m.ts).format('l LTS')}</td>
                        {
                          p.cmd === 'bounce' && <td>{m.code}</td>
                        }
                        </tr>)
                    }
                  </tbody>
                </Table>
                :
                <div className="text-center space-top-sm">
                  <h4>No events found!</h4>
                </div>)
          }
          </EDTableSection>
        </LoaderPanel>
      </SaveNavbar>
    );
  }
};



// WEBPACK FOOTER //
// ./src/containers/BroadcastDetails.js